import styled from "@mui/material/styles/styled";
import { Box } from "@mui/material";

import { InputTypeEnum, InputTypeEnumKeys } from "@type/Input";

const defaultBadgeStyle = {
  background: "#E0E0E0",
  border: "#BDBDBD",
  color: "#424242",
};

const badgeColors: Record<
  (typeof InputTypeEnum)[InputTypeEnumKeys],
  { background: string; border: string; color: string }
> = {
  Checkbox: { background: "#E3F2FD", border: "#BBDEFB", color: "#1E88E5" },
  Date: { background: "#E6F5ED", border: "#C4E5D2", color: "#2B8B58" },
  Email: { background: "#C6E0FF", border: "#67ACFF", color: "#0A5CC4" },
  Files: { background: "#EEE8FF", border: "#D2C8F7", color: "#5C44CA" },
  MultiInput: { background: "#F5E6B3", border: "#FFD751", color: "#BD9200" },
  Number: { background: "#E9EBFB", border: "#C7CCF6", color: "#1E3FC7" },
  Radio: { background: "#FFEBEE", border: "#FFCDD2", color: "#D32F2F" },
  RichTextBox: { background: "#F3E5FF", border: "#E3C2FE", color: "#A66AD7" },
  Select: { background: "#E2F4F2", border: "#B7E3DD", color: "#269483" },
  Slider: { background: "#EDE9E8", border: "#D7CCC8", color: "#795548" },
  Table: { background: "#F5F5F5", border: "#E9E9E9", color: "#757575" },
  Text: { background: "#FFF4E4", border: "#FFDBB8", color: "#F57C00" },
};

export const StyledBadge = styled(Box)<{
  type: (typeof InputTypeEnum)[InputTypeEnumKeys];
}>(({ type }) => {
  const styles = badgeColors[type] || defaultBadgeStyle;

  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: styles.background,
    border: `1px solid ${styles.border}`,
    color: styles.color,
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "0.875rem",
    fontWeight: "500",
    height: "20px",
    lineHeight: "16px",
  };
});
